import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PostLoginSsaService } from './authservices/post-login-ssa.service';
import { PostLoginBefrienderService } from './authservices/post-login-befriender.service';
import { PostLoginService } from './authservices/post-login.service';
import { PreLoginService } from './authservices/pre-login.service';

import { PagenotfoundComponent } from './portals/public/pagenotfound/pagenotfound.component';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./portals/public/public.module').then( m => m.PublicModule),

  },
  {
    path: 'admin',
    loadChildren: () => import('./portals/private/admin/admin.module').then( m => m.AdminModule),
    canActivate:[PostLoginService]
  },
  {
    path: 'community',
    loadChildren: () => import('./portals/private/ssa/ssa.module').then( m => m.SsaModule),
    canActivate:[PostLoginSsaService]
  },
  {
    path: 'befriender',
    loadChildren: () => import('./portals/private/befriender.module').then( m => m.BefrienderModule),
    canActivate:[PostLoginBefrienderService]
  },

  { path: '**', component: PagenotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
